import React, { useState, useEffect, useRef } from "react";
import SimpleBar from "simplebar-react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import $ from "jquery";
import PopUp from "./PopUp.js";
import Checkbox from "@material-ui/core/Checkbox";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

const CountingAreaReset = (props) => {
  const { t } = useTranslation();
  let countingAreas = props.data;
  let link = localStorage.getItem("link");
  const activeRights = JSON.parse(localStorage.getItem("rights"));

  const [popUpShow, setPopUpShow] = useState(false);
  const [currentcountingAreaData, setCurrentcountingAreaData] = useState();
  const popUpContainer = useRef(null);
  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  useEffect(() => {
    axios.get(link + "/api/Area?areaType=5", {}).then((response) => {
      localStorage.setItem(
        "areaCountingAreaType",
        JSON.stringify(response.data)
      );
    });
  });

  $(document).on("click", function (e) {
    if (
      popUpContainer.current &&
      !popUpContainer.current.contains(e.target) &&
      e.target.id != "settings-icon" &&
      !$(e.target).is(".settings-item") &&
      !$(e.target).children().hasClass("settings-item") &&
      !$(e.target).hasClass("select-icon") &&
      !$(e.target).parents(".rc-time-picker-panel").length == 1 &&
      !$(e.target).hasClass("rc-time-picker-clear") &&
      !$(e.target).hasClass("rc-time-picker-clear-icon") &&
      e.target.id != "pop-up-button"
    ) {
      setPopUpShow(false);
    }
  });

  function editCreateCountingArea(countingAreaData) {
    setCurrentcountingAreaData(countingAreaData);
    setPopUpShow(true);
  }

  const deleteCountingArea = (countingAreaData) => {
    let id = countingAreaData.id;

    confirmAlert({
      message: t("allgemein.bestaetigen"),
      buttons: [
        {
          label: t("allgemein.ja"),
          onClick: () =>
            axios
              .delete(link + "/api/CountingAreaReset/?id=" + id)
              .then((response) => {
                props.onChange();
              })

              .catch((error) => {}),
        },
        {
          label: t("allgemein.nein"),
        },
      ],
    });
  };

  function countingAreaResetList() {
    let countingAreaResetList = [];

    for (let i = 0; i < countingAreas.length; i++) {
      const fetchedAreaPath = countingAreas[i].areaPath;
      const areaPath = fetchedAreaPath.slice(0, -1).join(" -> ");
      const areaName = fetchedAreaPath[fetchedAreaPath.length - 1];
      const daysOfWeek = [
        t("allgemein.tageKurz.Sunday"),
        t("allgemein.tageKurz.Monday"),
        t("allgemein.tageKurz.Tuesday"),
        t("allgemein.tageKurz.Wednesday"),
        t("allgemein.tageKurz.Thursday"),
        t("allgemein.tageKurz.Friday"),
        t("allgemein.tageKurz.Saturday"),
      ];
      const chosenDaysOfWeek = countingAreas[i].weekdays
        .map(function (v, i) {
          return daysOfWeek[v];
        })
        .join(",");

      countingAreaResetList.push(
        <tr>
          <td>{areaPath}</td>
          <td>{areaName}</td>
          <td>{chosenDaysOfWeek}</td>
          <td>{countingAreas[i].resetTime}</td>
          <td>{countingAreas[i].resetValue}</td>
          <td>
            <Checkbox
              color="default"
              size="small"
              style={{ padding: "0px" }}
              checked={countingAreas[i].enabled}
              disabled
            />
          </td>
          <td>
            {activeRights.includes("CountingAreaReset.Update") && (
              <button
                className="button"
                id="pop-up-button"
                style={{ width: "80px" }}
                onClick={() => editCreateCountingArea(countingAreas[i])}
              >
                {t("allgemein.Bearbeiten")}
              </button>
            )}
            {activeRights.includes("CountingAreaReset.Delete") && (
              <button
                className="button"
                id="pop-up-button"
                style={{ width: "80px", marginLeft: "10px" }}
                onClick={() => deleteCountingArea(countingAreas[i])}
              >
                {t("allgemein.Loeschen")}
              </button>
            )}
          </td>
        </tr>
      );
    }

    return <tbody>{countingAreaResetList}</tbody>;
  }

  function popUpChange() {
    props.onChange();
    setPopUpShow(false);
  }

  return (
    <div>
      {popUpShow == true && (
        <div ref={popUpContainer}>
          {
            <PopUp
              type={"countingAreaReset"}
              data={currentcountingAreaData}
              onChange={popUpChange}
            >
              {" "}
            </PopUp>
          }
        </div>
      )}

      <div className="einstellungen-box">
        <div className="box-name">{t("administration.countingAreaReset")}</div>
        <div style={{ overflow: "auto" }}>
          <table id="countingAreaResetTable">
            <thead>
              <tr>
                <th colspan="2" style={{ textAlign: "left" }}>
                  {t("elementeAllgemein.area")}
                </th>
                <th colspan="5" style={{ textAlign: "left" }}>
                  {t("allgemein.timer")}
                </th>
              </tr>
              <tr>
                <td>{t("elementeAllgemein.areaPfad")}</td>
                <td>{t("elementeAllgemein.area")}</td>
                <td>
                  {t("occupancy.einstellung_helligkeitstimer.wochentage")}
                </td>
                <td>{t("administration.countingAreas.uhrzeit")}</td>
                <td>{t("administration.countingAreas.wert")}</td>
                <td>{t("allgemein.aktiv")}</td>
                <td>
                  {activeRights.includes("CountingAreaReset.Create") && (
                    <button
                      className="button"
                      id="pop-up-button"
                      style={{ width: "50px" }}
                      onClick={() => editCreateCountingArea()}
                    >
                      {t("allgemein.neu")}
                    </button>
                  )}
                </td>
              </tr>
            </thead>
            {countingAreaResetList()}
          </table>
        </div>
      </div>
    </div>
  );
};

export default CountingAreaReset;
